import * as React from 'react';
import { type ActionWithRulesAndAddersProps } from 'react-querybuilder';
import { Button } from '../../../buttons';
import { Icon } from '../../../icon';

export const AddRuleAction = (props: ActionWithRulesAndAddersProps) => {
  const { title, handleOnClick, disabled } = props;

  return (
    <Button
      size="small"
      onClick={handleOnClick}
      disabled={disabled}
      variant="ghost"
      className="c-query-builder__add-rule-btn"
      data-testid="cy-add-rule"
    >
      <Icon slot="prefix" name="plus" size="xsmall" />
      {title}
    </Button>
  );
};
